/**
 * Get translation to the current language for a provided key
 *
 * @param key {String} - identifier for string in translation files (e.g. 'Content.Label.FirstName')
 * @param args {Array} - values passed in to be inserted into translated string (e.g. 'Clock in time is _5:00PM_')
 * @return val {String} - translated string
 */
function getTranslation(key,args=[]) {
  let language_chosen = lang_en;

  // Check global settings for language, defaulting to English unless overridden with a legit setting (only Spanish so far)
  if ( g.clientSettingsObj && g.clientSettingsObj.userLocale !== null ) {
    if ( g.clientSettingsObj.userLocale === "es_MX" ) {
      language_chosen = lang_es;
    }
  }

  // can't find translation with given key
  if (typeof language_chosen[key] === "undefined") {
    Bugsnag.notify("JS i18n key missing: " + key);
    return "xxx i18n xxx";
  }
  else {
    let val = language_chosen[key]; // string pulled from translation file
    // replace any {1}, {2}, {3}... placeholders in the string with values from the args array
    if ( args.length > 0 ){
      for( let i=0; i < args.length; i++ ){
        let placeHolder = "{" + ( i+1 ) + "}";
        val = val.replace(placeHolder, args[i]);
       }
    }
    let debug = g.clientSettingsObj && g.clientSettingsObj.localeDebugMarking;
    // CF may emit true/false, "true"/"false", or YES/NO — treat only affirmative values as enabled
    let debugOn = debug === true || /^(true|yes|1)$/i.test(String(debug));
    return debugOn ? "*** " + val + " ***" : val;
  }
}
